"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryCard = exports.MainTop = exports.MainBottom = exports.AttributionWrapper = void 0;
exports.ProductMarqueeSingle = ProductMarqueeSingle;
exports.default = exports.ProductMarqueeSingleSection = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _density = require("@site/pattern-library-utils/density");
var _index = _interopRequireDefault(require("../../../elements/other/card/index.js"));
var _attributionBlock = _interopRequireDefault(require("@site/pattern-library-core/attribution-block"));
/* eslint-disable complexity */

const ProductMarqueeSingleSection = exports.ProductMarqueeSingleSection = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "ProductMarqueeSingleSection",
  class: "pl-p1dfwekn",
  vars: {
    "p1dfwekn-0": [({
      mobile
    }) => mobile ? `url(${mobile})` : 'initial'],
    "p1dfwekn-1": [({
      backgroundColor
    }) => backgroundColor ? backgroundColor : `${_intents.default.ux.boxLowContrast.backgroundColor}`],
    "p1dfwekn-2": [({
      invert
    }) => invert ? _intents.default.ux.box.backgroundColor : _intents.default.ux.box.foregroundColor],
    "p1dfwekn-4": [({
      tablet
    }) => tablet ? `url(${tablet})` : 'initial'],
    "p1dfwekn-6": [({
      desktop
    }) => desktop ? `url(${desktop})` : 'initial']
  }
});
const PrimaryCard = exports.PrimaryCard = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PrimaryCard",
  class: "pl-p1p191bu",
  vars: {
    "p1p191bu-0": [({
      alignment
    }) => alignment === 'center' ? 'center' : 'space-between'],
    "p1p191bu-1": [({
      alignment
    }) => alignment],
    "p1p191bu-3": [({
      hasMobileImage
    }) => hasMobileImage ? '15rem' : '2rem']
  }
});
const MainTop = exports.MainTop = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MainTop",
  class: "pl-m58ppgg",
  vars: {
    "m58ppgg-1": [({
      alignment
    }) => alignment === 'center' ? 'center' : 'flex-start'],
    "m58ppgg-2": [({
      alignment
    }) => alignment === 'center' ? '42em' : '32em']
  }
});
const MainBottom = exports.MainBottom = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MainBottom",
  class: "pl-m11x7xib",
  vars: {
    "m11x7xib-1": [({
      justifyContent
    }) => justifyContent === 'bottom-right' ? 'flex-end' : 'flex-start'],
    "m11x7xib-2": [({
      alignment
    }) => alignment === 'center' ? 'auto' : '0']
  }
});
const AttributionWrapper = exports.AttributionWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "AttributionWrapper",
  class: "pl-a1hyysvk"
});

/**
 * Render product marquee.
 *
 * @param {object} props React props
 * @param {React.ReactElement} props.card Primary Card definition (required)
 * @param {string} props.attributionName Attribution name  (optional)
 * @param {string} props.attributionPosition Attribution Position  (optional)
 * @param {string} props.attributionUrl Attribution url (optional)
 * @param {object} props.backgroundImages Object of background images for all breakpoints.
 * @param {object} props.priceLockup Price Lockup
 * @param {string} props.attributionHeadline Attribution Headline (optional)
 * @param {string} props.attributionDescription Attribution Description (optional)
 * @returns {React.ReactElement} Full Marqueecomponent
 * @public
 */
function ProductMarqueeSingle({
  backgroundImages,
  backgroundColor,
  invert,
  marqueeLayout,
  attributionName,
  attributionPosition,
  card,
  priceLockup,
  countdownClock,
  attributionHeadline,
  attributionDescription,
  ...cardProps
}) {
  const alignment = marqueeLayout === 'centered-single' ? 'center' : 'start';
  const dataCy = marqueeLayout === 'centered-single' ? 'product-marquee-centered' : 'product-marquee-start';
  const {
    mobile
  } = backgroundImages;
  return /*#__PURE__*/_react.default.createElement(ProductMarqueeSingleSection, (0, _extends2.default)({
    "data-cy": dataCy,
    invert: invert,
    backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor)
  }, cardProps, backgroundImages), /*#__PURE__*/_react.default.createElement(PrimaryCard, {
    "data-cy": "primary-card",
    hasMobileImage: mobile?.length > 0,
    alignment: alignment
  }, /*#__PURE__*/_react.default.createElement(MainTop, {
    "data-cy": "main-top",
    alignment: alignment
  }, card && /*#__PURE__*/_react.default.isValidElement(card) ? (/*#__PURE__*/_react.default.cloneElement(card, {
    padding: 'none',
    indented: true,
    textAlign: alignment,
    ctas: cardProps.ctas,
    ...card.props
  })) : /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
    padding: "none",
    indented: true
  }, cardProps, card, {
    textAlign: alignment,
    priceLockup: priceLockup
  })), countdownClock), (attributionName || attributionHeadline || attributionDescription) && /*#__PURE__*/_react.default.createElement(MainBottom, {
    "data-cy": "main-bottom",
    alignment: alignment,
    justifyContent: attributionPosition
  }, /*#__PURE__*/_react.default.createElement(AttributionWrapper, null, /*#__PURE__*/_react.default.createElement(_attributionBlock.default, {
    isBasic: true,
    hideOnMobile: true,
    attributionPosition: attributionPosition ?? 'bottom-left',
    attribution: attributionName || attributionHeadline
  }), attributionDescription && /*#__PURE__*/_react.default.createElement(_attributionBlock.default, {
    isBasic: true,
    hideOnMobile: true,
    attributionPosition: attributionPosition ?? 'bottom-left',
    attribution: attributionDescription
  })))));
}
ProductMarqueeSingle.propTypes = {
  backgroundImages: _propTypes.default.shape({
    mobile: _propTypes.default.string,
    tablet: _propTypes.default.string,
    desktop: _propTypes.default.string
  }),
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })]),
  attributionName: _propTypes.default.string,
  attributionPosition: _propTypes.default.string,
  invert: _propTypes.default.bool,
  cardProps: _propTypes.default.shape({
    ..._index.default.propTypes
  }),
  card: _propTypes.default.node,
  marqueeLayout: _propTypes.default.oneOf(['centered-single', 'start-single']).isRequired,
  priceLockup: _propTypes.default.object,
  countdownClock: _propTypes.default.node,
  attributionHeadline: _propTypes.default.string,
  attributionDescription: _propTypes.default.string
};
var _default = exports.default = ProductMarqueeSingle;